import { render, staticRenderFns } from "./dashboardAgent.vue?vue&type=template&id=2895abdc&scoped=true"
import script from "./dashboardAgent.vue?vue&type=script&lang=js"
export * from "./dashboardAgent.vue?vue&type=script&lang=js"
import style0 from "./dashboardAgent.vue?vue&type=style&index=0&id=2895abdc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895abdc",
  null
  
)

export default component.exports